import React from 'react'
import { MAPPED_OR_TRANSFERRED_ATTRIBUTE_VALUES, UNIQUE_ATTRIBUTE_VALUES, VIEW_ALL } from '../utils/Constants';
import { ArrowRight } from "Components/DesignSystem/Iconography/Icons";
import Button from 'Components/DesignSystem/Button/Button';

type UniqueAttributeValuesProps = {
    payload: TRecategorizePayload;
    attributeValues: AttributeValue[];
    setAttributeValueData: React.Dispatch<React.SetStateAction<AttributeValueMapping | null>>;
    sourceAttributeId: string;
    targetAttributeId: string;
}
const UniqueAttributeValues = ({ payload, attributeValues, sourceAttributeId, targetAttributeId, setAttributeValueData }: UniqueAttributeValuesProps) => {
    const handleViewAll = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {

        e.stopPropagation();
        setAttributeValueData({
            selectedSourceAttribute: sourceAttributeId,
            selectedTargetAttribute: targetAttributeId,
            showAttributeValuesMapping: true,
            attributeValuesCount: attributeValues.length,
            payload: payload
        });
    }
    const mappedOrCreatedCount = attributeValues.filter(value => {
        const uniqueValue = payload.unique_attr_source_list
            .find(attr => attr.attribute_id === sourceAttributeId)
            ?.unique_attribute_values
            ?.find(val => val.attribute_value === value.value);

        return uniqueValue?.action === 'map' && uniqueValue.target_attribute_value || uniqueValue?.action === 'create';
    }).length;

    return (
        <div className="tw-flex tw-flex-col tw-gap-4">
            <div className="tw-flex tw-items-center">
                <div>{UNIQUE_ATTRIBUTE_VALUES}</div>
            </div>

            <div className="tw-flex tw-items-center tw-gap-4">
                <span className="tw-text-ink tw-text-sm tw-font-medium">{attributeValues.length} Attributes values found</span>
                {/*
                  * Was main.css `.outline-button` — a baked `#091caa` border and ink, plus a
                  * hand-set 120x30 box, plus an `<img>` arrow that could never take
                  * currentColor. DS `Button secondary sm` is the same affordance on the
                  * control grid; the guarded onClick and the native `disabled` are verbatim.
                  */}
                <Button
                    variant="secondary"
                    size="sm"
                    data-testid="recategorize-unique-values-view-all-btn"
                    disabled={attributeValues?.length <= 0}
                    onClick={(e) => { if (attributeValues?.length > 0) handleViewAll(e) }}
                    icon={<ArrowRight size={16} />}
                    iconPosition="end"
                >
                    {VIEW_ALL}
                </Button>
            </div>

            <div className="tw-flex tw-items-center tw-gap-4">
                <span>{MAPPED_OR_TRANSFERRED_ATTRIBUTE_VALUES}</span>
                <div className="tw-bg-surface-sunken tw-px-3 tw-py-1 tw-rounded">
                    {mappedOrCreatedCount} / {attributeValues.length}
                </div>
            </div>
        </div>
    );
}

export default UniqueAttributeValues